module.exports = __webpack_public_path__ + "static/media/incentivesMetaImage.084731b7.png";